import dmytroIMG from '../../assets/images/about-founder.png';

export const projectAuthorData = {
    name: 'Dmytro Kiriachek',
    position: 'Gründer von Nexon Digital Studio',
    image: dmytroIMG,
    imageAlt: 'Dmytro Kiriachek von Nexon Digital Studio',
};
